import { Observable } from 'rxjs/Observable';
import cardsFlagWithCommentRequest from '../../rest/cards-flag-with-comment/index.tsx';
import type { CardsFlagWithCommentResponse } from '../../rest/cards-flag-with-comment/types.tsx';
import type { CardsFlagWithCommentRequestAction } from '../../state/actions/cards/flag-with-comment/index.tsx';
import { getCards } from '../../state/selectors/cards/index.tsx';
import type { MiddlewareAPI } from '../../state/types.tsx';

export const cardsFlagWithCommentService = (
	store: MiddlewareAPI,
	action: CardsFlagWithCommentRequestAction,
): Observable<CardsFlagWithCommentResponse> => {
	const {
		payload: { cards, flag, comment },
	} = action;
	const state = store.getState();
	const allCards = getCards(state);
	const issueKeys = cards.map((id) => allCards[String(id)].key);
	return Observable.fromPromise(cardsFlagWithCommentRequest(issueKeys, flag, comment));
};

export default cardsFlagWithCommentService;
